import { useEffect } from 'react';

import { Routes, Route, useLocation } from 'react-router-dom';

import indexRoutes from './routes/indexRoutes';

import PublicLayout from './layouts/PublicLayout';
import NotFound from './components/Pages/NotFound';
import ServerError from './components/Pages/ServerError';
import AppVersionChecker from './components/AppVersionChecker';

import 'antd/dist/reset.css';
import './App.less';

// 全局监听路由 - 离开页面自动还原默认title - 解决：上一个页面的标题残留问题
function useResetTitle() {
    const location = useLocation();

    useEffect(() => {
        return () => {
            document.title = '华媒康讯业务运营支持系统';
        };
    }, [location.pathname]);
}

function App() {
    useResetTitle();
    const nestedRoutes = routes =>
        routes.map((route, index) => {
            const routeKey = route.path ?? (route.index ? `index-${index}` : `route-${index}`);
            if (route.index) {
                return <Route key={routeKey} index element={route.element} />;
            }
            if (route.children && route.children.length) {
                return (
                    <Route key={routeKey} path={route.path} element={route.element}>
                        {nestedRoutes(route.children)}
                    </Route>
                );
            }
            return <Route key={routeKey} path={route.path} element={route.element} />;
        });

    return (
        <div className="App">
            <AppVersionChecker />
            <Routes>
                {nestedRoutes(indexRoutes)}

                <Route path="" element={<PublicLayout />}>
                    <Route path="500" element={<ServerError />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
